import React, { useState } from "react";
import "./Track_order.css";

function TrackOrder() {

  const [orderNo, setOrderNo] = useState('');
  const [orderEmail, setOrderEmail] = useState('');

  function handleTrackOrder(e) {
    e.preventDefault();
  }
  return (
    <div className="track-order-form">
      <h2>Track An Order</h2>
      <p>Enter the order number you would like to track in the form below.</p>
      <div className="track-order-form-group">
        <label htmlFor="orderNo">Order Number</label>
        <input
          type="text"
          id="orderNo"
          onChange={(e) => setOrderNo(e.target.value)}
        />
      </div>
      <div className="track-order-form-group" >
        <label htmlFor="orderEmail">Order Email</label>
        <input
          type="email"
          id="orderEmail"
          onChange={(e) => setOrderEmail(e.target.value)}
        />
      </div>
      <button className='track-order-form-button' disabled={(orderNo && orderEmail) ? false : true} onClick={handleTrackOrder}>Track</button>
    </div>
  );
}

export default TrackOrder;